module.exports = __webpack_public_path__ + "img/MOBILE_Slide5.240b7e68.png";